<template src="./index.html"></template>
<style lang="scss" scoped src="./index.scss"></style>
<script>
import { Dialog, Toast } from 'vant';
export default {
  name: "DetailsLabelPage",
  data() {
    return {
      dataList: [],
      member_id: '',
      requestType: true
    };
  },
  mounted() {
    let obj = {
      source: this.$route.query.source, 
      ww_nick: this.$route.query.ww_nick,
      buyer_openuid: this.$route.query.buyer_openuid
    }
    this.$store.dispatch("AddressBook/GetSetLabel", obj).then((res) => {
      if (res.code == 1000) {
        this.member_id = res.data.member_id
        for(let i in res.data.list) {
          if(res.data.list[i].label !== "自定义标签") {
            for(let j=0; j<res.data.list[i].data.length; j++) {
              if(res.data.list[i].data[j].label_selected == '0') {
                res.data.list[i].data.splice(j--, 1)
              }
            }
          }
        }
        this.dataList = res.data.list;
      }
    });
  },
  methods: {
    
    // 判断子标签样式
    LabelItemClass(key) {
      const ClattMap = ["ItemOne", "ItemTwo", "ItemThree"];
      const KeyMap = [
        ["order_type", "custom_type", "member_type", "customized"],
        ["custom_level", "recall_num", "expired_date"],
        ["custom_order_fee", "pay_cycle"],
      ];
      let ClassName = null;
      KeyMap.map((n, i) => {
        if (n.includes(key)) {
          ClassName = ClattMap[i];
        }
      });
      return ClassName;
    },
    // 选择标签
    SelectLabelItem(index, i_index) {
      if(this.dataList[index].label=="自定义标签") {
        this.dataList[index].data[i_index].label_selected = this.dataList[index].data[i_index].label_selected==0 ?1 :0
      }
    },
    SaveButton() {
      let str = ''
      let arr = []
      for(let i in this.dataList) {
        if(this.dataList[i].label == "自定义标签") {
          for(let j=0; j<this.dataList[i].data.length; j++) {
            if(this.dataList[i].data[j].label_selected == '1') {
              arr.push(this.dataList[i].data[j].label_value)
            }
          }
        }
      }
      for(let i in arr) {
        if(i < arr.length-1) {
            str += arr[i]+','
          }else {
            str += arr[i]
          }
      }
      let obj = {
        member_id: this.member_id, 
        value: str
      }
        
      if(this.requestType) {
        this.requestType = false
        this.$store.dispatch("AddressBook/customerMarking", obj).then((res) => {
          if (res.code == 1000) {
            Toast("保存成功")
            setTimeout(()=>{
              this.$router.back(-1)
              // this.$router.push({name:'AddressBook', params: {LabelParams:this.SelectLabelItemActive} })
            },2000)
          }
        });
      }
    },
  },
};
</script>